import React from 'react';
import { Box, Typography } from '@mui/material';

// Legenda do destaque de expediente — só faz sentido com um profissional selecionado,
// então quem renderiza controla a visibilidade.
export default function BusinessHoursLegend() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        mb: 1,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <span className="agenda-legend-swatch agenda-legend-swatch--business" />
        <Typography variant="caption" color="text.secondary">
          Horários que o profissional atende
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <span className="agenda-legend-swatch agenda-legend-swatch--non-business" />
        <Typography variant="caption" color="text.secondary">
          Horários que o profissional não atende
        </Typography>
      </Box>
    </Box>
  );
}
